import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../views/Layout.vue'
import OrderDetails from '../views/OrderDetails.vue'
//Website
import Landing from '../views/website/Landing.vue'
//Panel
import Login from '../views/panel/Login.vue'
import BaseLayout from '../views/panel/BaseLayout.vue'
import Me from '../views/panel/pages/Me.vue'
import Orders from '../views/panel/pages/Orders.vue'
import Branches from '../views/panel/pages/Branches.vue'
import Products from '../views/panel/pages/Products.vue'

const isAuthenticated = () => !!localStorage.getItem('menui-token');

const routes = [
  {
    path: '/',
    name: 'establishments',
    component: () => {
      if(window.innerWidth > 768) {
        return Promise.resolve(Landing)
      } else {
        return Promise.resolve(Layout)
      }
    }
  },
  {
    path: '/order/:establishment_id/:order_id',
    name: 'order-details',
    component: OrderDetails
  },
  {
    path: '/panel/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/panel',
    component: BaseLayout,
    redirect: '/panel/me', 
    meta: { requiresAuth: true },
    children: [
      {
        path: '/panel/me',
        name: 'me',
        component: Me,
        meta: { requiresAuth: true }
      },
      {
        path: '/panel/orders',
        name: 'orders',
        component: Orders,
        meta: { requiresAuth: true }
      },
      {
        path: '/panel/branches',
        name: 'branches',
        component: Branches,
        meta: { requiresAuth: true }
      },
      {
        path: '/panel/products',
        name: 'products',
        component: Products,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  
  //Validación general de login
  if (to.meta.requiresAuth) {
    if (!isAuthenticated()) {
      return next('/panel/login')
    }
  }

  next()

})

export default router
